module.exports = __webpack_public_path__ + "static/florida-1a221bfa170d818f39e3530b35fb3e8d.png";